
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kurumsal/[slug]",
      function () {
        return require("private-next-pages/kurumsal/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kurumsal/[slug]"])
      });
    }
  